<template>
    <div id="app" style="height: 100vh" v-cloak>
        <iframe id="iframeId" ref="iframe" frameborder="0" height="100%" width="100%" src="http://123.124.130.23:8085/susong/"></iframe>
        <div style="position: fixed; z-index: 99; height: 30px; width: 30px; top: 0; right: 16px; line-height: 46px;" @click.stop="exitRiskAssessment">
            <img src="../../../static/images/close-blue.png" alt="" style="height:14px; width:14px;">
        </div>
    </div>
</template>
<script>
	export default {
		data: function() {
			return {

            }
        },
        mounted: function() {

        },
        methods: {
            exitRiskAssessment() {
                wx.miniProgram.navigateTo({url: '/pages/caseInfo/main'})
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/riskAssessment/index.vue